import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axios from "axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8">
        <Logo />
        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto h-10 w-10 text-emerald-500" />
            <h1 className="h-display mt-4 text-xl font-semibold text-foreground">Check your inbox</h1>
            <p className="mt-2 text-sm text-muted-foreground">If <span className="font-medium">{email}</span> has an account, a reset link is on its way. It expires in 1 hour.</p>
            <Link to="/login" className="mt-6 inline-block text-sm font-medium text-primary hover:underline" data-testid="forgot-back-login">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="h-display mt-8 text-2xl font-semibold text-foreground">Forgot your password?</h1>
            <p className="mt-1 text-sm text-muted-foreground">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@company.com" className="mt-1" data-testid="forgot-email" />
              </div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
              </Button>
            </form>
            <p className="mt-6 text-center text-sm text-muted-foreground">
              Remembered it? <Link to="/login" className="font-medium text-primary hover:underline" data-testid="forgot-signin-link">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
